import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import VsCssbuyPage from "@/pages/vs-cssbuy/page";
import VsSuperbuyPage from "@/pages/vs-superbuy/page";
import VsOopbuyPage from "@/pages/vs-oopbuy/page";
import SafetyGuidePage from "@/pages/safety-guide/page";
import BeginnersGuidePage from "@/pages/beginners-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kakobuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/kakobuy-vs-cssbuy",
    element: <VsCssbuyPage />,
  },
  {
    path: "/kakobuy-vs-superbuy",
    element: <VsSuperbuyPage />,
  },
  {
    path: "/kakobuy-vs-oopbuy",
    element: <VsOopbuyPage />,
  },
  {
    path: "/kakobuy-safety-guide",
    element: <SafetyGuidePage />,
  },
  {
    path: "/kakobuy-beginners-guide",
    element: <BeginnersGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;